import React, { Component } from 'react';
import Helmet from "react-helmet";
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Bet from '../../components/toto/bet';

// @inject('lineStore')
// @withRouter
export default class BetPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Карточка тотализатора</title>
					</Helmet> 
					<div className="toto-page__body">
						<Bet />
					</div>
				</div> 
			)
	}
}


// WEBPACK FOOTER //
// ./src/routes/toto/bet.jsx